// @flow
import * as React from 'react';
import ReactFlow, {
  Background,
  Controls,
  ControlButton,
  removeElements,
} from 'react-flow-renderer';
import classNames from 'classnames';

import Icon from 'sail/Icon';
import * as Assets from 'sail/Icon/Assets';
import ModalLayer from 'sail/ModalLayer';
import Box from 'sail/Box';
import Group from 'sail/Group';

import {CodeBlock} from 'docs/components';
import './DiagramGenerator.scss';
import {useDiagramGenerator} from 'docs/data/diagram';
import {AddNode} from './components/AddNode';
import {AddEdge} from './components/AddEdge';
import {nodeTypes} from '../nodeTypes';
import {edgeTypes} from '../edgeTypes';
import {DiagramSelector} from './components/DiagramSelector';

const AddNodeDialog = () => {
  const {showNodeModal, setShowNodeModal} = useDiagramGenerator();
  return (
    <ModalLayer
      shown={!!showNodeModal}
      onWashClick={() => {
        setShowNodeModal(false);
      }}
      onEscape={() => {
        setShowNodeModal(false);
      }}
    >
      <AddNode />
    </ModalLayer>
  );
};

const AddEdgeDialog = () => {
  const {edge, setEdge} = useDiagramGenerator();
  const showEdgeModal = !!edge.from && !!edge.to;
  return (
    <ModalLayer
      shown={!!showEdgeModal}
      onWashClick={() => {
        setEdge({to: '', from: ''});
      }}
      onEscape={() => {
        setEdge({to: '', from: ''});
      }}
    >
      <AddEdge />
    </ModalLayer>
  );
};

const MarkdocCodeBlock = () => {
  const {markdoc} = useDiagramGenerator();
  return (
    <CodeBlock filename="diagram.md" language="markdoc">
      {markdoc}
    </CodeBlock>
  );
};

export const DiagramGeneratorContent = () => {
  // State required to render the diagram
  const {
    type,
    elements,
    onElementsRemove,
    showHandles,
    addEdge,
    onNodeDragStop,
    setShowNodeModal,
  } = useDiagramGenerator();

  return (
    <Group spacing={16} padding={{top: 12}}>
      <DiagramSelector />
      <Box>
        <Group>
          <Box
            className={classNames(
              'Diagram',
              'DiagramGeneratorContent',
              `DiagramGeneratorContent--${type}`,
              !showHandles && 'hideHandles',
            )}
            padding={{top: 12}}
          >
            <ReactFlow
              elements={elements}
              nodeTypes={nodeTypes}
              edgeTypes={edgeTypes}
              onLoad={(reactFlowInstance) => {
                reactFlowInstance.fitView();
              }}
              nodesConnectable
              nodesDraggable={type !== 'sequence'}
              onConnect={addEdge}
              connectionMode="loose"
              onNodeDragStop={onNodeDragStop}
              snapToGrid
              snapGrid={[8, 8]}
              onElementsRemove={(elsToRemove) => {
                onElementsRemove(
                  elsToRemove,
                  removeElements(elsToRemove, elements),
                );
              }}
            >
              <Background variant="dots" gap={16} size={1} color="#C0C8D2" />
              <Controls>
                <ControlButton onClick={() => setShowNodeModal(true)}>
                  <Icon icon={Assets.addCircle} color="purple" />
                </ControlButton>
              </Controls>
            </ReactFlow>
            <AddNodeDialog />
            <AddEdgeDialog />
          </Box>
        </Group>
        <MarkdocCodeBlock />
      </Box>
    </Group>
  );
};
